import React from "react";
import c from "./AccommodationPacketItem.module.scss";
import RoomPriceMealIcon from '../../../../../../../../../components/ui/icons/hotels/rooms/RoomPriceMealIcon';
import { RoomItemPriceType } from "../../../../../../../../../types/rooms";
import AppButton from "../../../../../../../../../components/ui/components/Buttons/AppButton/AppButton";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { getDifferenceInNights } from "../../../../../../../../../helpers/date";
import { updateQueryStringParameter } from "../../../../../../../../../helpers/url";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getHotelSelector } from "../../../../../../../../../store/hotel/hotel-selector";


interface IProps {
  children?: React.ReactNode;
  price: RoomItemPriceType;
  accommodationPacket: {
    arrivalDate: string
    departureDate: string
  }
}


const AccommodationPacketItem: React.FC<IProps> = ({ price, accommodationPacket }) => {
  const [t] = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const {alias} = useSelector(getHotelSelector).data;

  const {
    arrivalDate,
    departureDate,
  } = accommodationPacket;


  const changeDates = () => {
    const arrival = dayjs(arrivalDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
    const departure = dayjs(departureDate, 'YYYY-MM-DD').format('YYYY-MM-DD')

    const params = new URLSearchParams(location.search);

    params.set('arrival_date', arrival);
    params.set('departure_date', departure);

    history.push(`/hotels/${alias}?${params.toString()}`);

  }


  const days = getDifferenceInNights(arrivalDate, departureDate);
  const startFormat = dayjs(arrivalDate, 'YYYY-MM-DD').format('DD.MM');
  const endFormat = dayjs(departureDate, 'YYYY-MM-DD').format('DD.MM');

  return (
    <div className={c.accommodationPacketItem}>
      <div className={c.accommodationPacketItemMeal}>
        <RoomPriceMealIcon variant={price.mealType.code}/>
        <div className={c.accommodationPacketItemMealText}>{price.mealType && price.mealType.name}</div>
      </div>

      <div className={c.accommodationPacketItemText}>
        {t('accommodation_package_message', {count: days, startFormat, endFormat})}
      </div>


      <AppButton
        onClick={changeDates} theme={'outline'}
        color={'green'}
        size="small"
      >
        {t("Змінити дати")}
      </AppButton>


    </div>
  );
};

export default AccommodationPacketItem;